import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './DirectSale.css';
import { X } from 'lucide-react';

const DirectSale = () => {
  const [formData, setFormData] = useState({
    name: '',
    lastName: '',
    companyName: '',
    phoneNo: '',
    visibility: ''
  });
  
  const handleBack = () => navigate(-1);
  const [price, setPrice] = useState(0);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [showTerms, setShowTerms] = useState(true);
  const navigate = useNavigate();

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value, type } = e.target;
    
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'radio' ? value : value
    }));

    // Update price based on visibility selection
    // if (name === 'visibility') {
    //   switch (value) {
    //     case '1X Visibility': setPrice(500000); break;
    //     case '2X Visibility': setPrice(900000); break;
    //     case '3X Visibility': setPrice(1400000); break;
    //     case '4X Visibility': setPrice(1800000); break;
    //     default: setPrice(0);
    //   }
    // }
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    console.log('Payment amount:', price);
    
    setFormData({ name: '', lastName: '', companyName: '', phoneNo: '', visibility: '' });
    setPrice(0);
    setTermsAccepted(false);
    navigate('/sign-in');
  };

  return (
    <div className="direct-sale-container text-xs"> {/* Small font size */}
      <h1 className="text-lg font-bold">Direct Sale Page</h1>
       <button
            onClick={handleBack}
            className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
          >
            <X size={20} />
          </button>


      {/* Terms and Conditions Section */}
      <div className="content-box p-4 border rounded-md bg-gray-100 relative text-[10px]">

        <h2 className="font-semibold">BuildPro-OGCS: Terms and Conditions for the Sale by Seller Module</h2>
        <p><strong>1. Visibility Charges:</strong> The seller must select one visibility option for their product, which can be from the following tiers:</p>
        <ul className="list-disc list-inside">
          <li>1X Visibility</li>
          <li>2X Visibility</li>
          <li>3X Visibility</li>
          <li>4X Visibility</li>
        </ul>
        <p>Visibility charges vary depending on the product category and the price of the product. A detailed chart of applicable charges will be provided to the seller.</p>
        <p>Additional options include 1X + Video, 3X + Video, and PowerPack Visibility with extra charges and These options come with additional applicable charges.</p>

        <p><strong>2. Sales Process and Payment Flow:</strong></p>
        <ul className="list-disc list-inside">
          <li>Product Listing: Once the product is listed, it will be available for buyers to view. When a buyer adds the product to their cart, the contact details of both the seller and the buyer will be shared.</li>
          <li>Buyer-Seller Interaction: After the contact details are shared, all further communication, negotiations, and the selling process will be handled directly between the seller and the buyer. BuildPro-OGCS will not be involved in the transaction after the product is listed.
</li>
</ul>
        <p><strong>3. Payment to Seller:</strong> </p>
        <li>The seller will receive payment directly from the buyer after the product purchase is completed. Alternatively, payment terms can be negotiated directly between the buyer and the seller.</li>
        <li>BuildPro-OGCS facilitates the connection between the seller and the buyer, but the seller is responsible for managing the transaction, payment collection, delivery, and all related processes.</li>
        <li>No Convenience Charges: No convenience charges are applicable for this module. Only the visibility charges selected by the seller will apply.</li>


        <p><strong>4. GST:</strong> GST will be applicable as per prevailing tax rates. The seller will charge GST separately from the product price, which will be included in the invoice.</p>

        <p><strong>5. Tax Invoices:</strong> The tax invoice for the product will be issued directly between the seller and the buyer, including both their addresses and the product details.</p>

        <p><strong>6.Optional Visibility Charges:</strong></p>
        <ul className="list-disc list-inside">
          <p>For enhanced visibility options, the following charges apply:</p>
          <li>1X + Video: Additional charge for video-based visibility to boost product attraction</li>
          <li>3X + Video: Enhanced video visibility for maximum reach.</li>
          <li>PowerPack Visibility: Premium visibility option, offering top placement on the website and streamlined product listing.</li>
          <p>These are optional and can be selected by the seller to increase product exposure.</p>
        </ul>
      </div>


<div className="content-box mt-4 p-4 border rounded-md text-[10px]">
<h3 className="font-semibold">Refund Terms and Conditions for the Seller Platform</h3>
<p> 1. Registration Cancellation:</p>
<ul className="list-disc list-inside">
  <li>Sellers or manufacturers who register with BuildPro-OGCS may cancel their registration; however, no refund will be applicable in such cases.</li>
</ul>

<p> 2. Registration Timeframe:</p>
<ul className="list-disc list-inside">
  <li>Registration charges are valid for a period of three years. If a seller does not actively use the platform during this period, they may request a one-year grace period by submitting a written request. Upon approval, the seller can continue their registration.</li>
</ul>

<p>3. Cancellation Before Product Displayed on Platform:</p>
<ul className="list-disc list-inside">
  <li>If a seller wishes to cancel a product or all products before they are displayed on the BuildPro-OGCS platform, a 10% administration charge will be deducted from the total Visibility Charges. The remaining balance will be refunded upon receiving a written cancellation request from the seller.</li>
</ul>

<p> 4. Cancellation After Product Displayed on Website:</p>
<h4 className="font-semibold mt-2">If a product has been displayed on the BuildPro-OGCS platform, the following refund policy applies for cancellations during the first year:</h4>
<ul className="list-disc list-inside">
  <li>Within 1 week: A 12% deduction from the total Visibility Charges.</li>
  <li>After 1 week but within 3 months: A 50% deduction from the total Visibility Charges.</li>
  <li>After 3 months but within 6 months: A 75% deduction from the total Visibility Charges.</li>
  <li>After 6 months: No refund will be applicable.</li>
  <li>If the product remains unsold or the seller is not connected with at least three prospective buyers within one year, BuildPro-OGCS will take responsibility and initiate a 90% refund of the Visibility Charges. This refund will be processed within 15 working days after the completion of one year.

</li>
</ul>

<p> 5. Cancellation Due to Force Majeure:</p>
<ul className="list-disc list-inside">
  <li>In the event of force majeure (e.g., government bans, legal restrictions), no cancellation or refund will be possible.</li>
  <li>If a product is found to be involved in unlawful activities, BuildPro-OGCS will immediately cancel the listing, and no refund will be issued. The seller will be solely responsible for any legal consequences, penalties, or fees arising from such activities.</li>
  <p>These terms and conditions are designed to ensure a clear and smooth transaction process between BuildPro-OGCS, the sellers, and the buyers, while maintaining transparency and compliance with applicable laws.</p>
</ul>
   </div>
      {/* Sales Information */}
      <div className="content-box mt-4 p-4 border rounded-md text-[10px]">
        <h3 className="font-semibold">Sale by Seller</h3>
        <p>Full Control with BuildPro OGCS’s Powerful Marketing Support
        This module is perfect for manufacturers who want to control their sales but leverage BuildPro OGCS's powerful markeing tools. You handle the sales and transactions, and we ensure your products are seen by the right buyers.
         </p>

        <h4 className="font-semibold mt-2">How It Works:</h4>
        <ul className="list-disc list-inside">
          <p>Registration :</p>
          <li>Registration per seller (irrespective of product quantity or amount).</li>
          <p>Visibility Options: </p>
          <li>Choose from our visibility tiers to determine how prominently your products appear on the platform. </li>

          <p>Direct Inquiries :</p>
          <li>Buyers contact you directly to negotiate and place orders.</li>

          <p>Order Fulfillment: </p>
          <li>You manage all sales, delivery, and after-sales support.</li>

          <p>Genuine Customer: </p>
          <li>we provide you with genuine clients as compared to other e-commerce sites, you will get refined, genuine clients. No leads will come from other categories. Along with that, you can assess based on the product specifications and decide whether you want to purchase a particular product or not</li>
        </ul>

       

        <h4 className="font-semibold mt-2">Visibility Modules :</h4>
        <ul className="list-disc list-inside">
          <p>Our visibility modules (1X, 2X, 3X, and 4X) allow you to customize how prominently your products appear to buyers on the platform:</p>
          <li>1X Visibility: Basic listing, ideal for those looking for standard visibility</li>
          <li>2X Visibility: Enhanced exposure, making your product more noticeable to buyers.</li>
          <li>3X Visibility: Premium visibility, attracting a larger audience for high-demand products.</li>
          <li>4X Visibility: Maximum exposure, ensuring your products stand out to a wide audience of serious buyers</li>
        </ul>

        <h4 className="font-semibold mt-2">Video Ad Options:</h4>
        <p>For sellers with innovative products, add a short promotional video to your visibility package for extra engagement. Videos can significantly increase buyer interest by showcasing product features effectively.</p>

        <h4 className="font-semibold mt-2">Additional Visibility for Innovative Products :</h4>
        <p>For new and groundbreaking products, BuildPro OGCS offers exclusive video-based visibility options to enhance engagement and attract more attention from potential </p>

        <h4 className="font-semibold mt-2">Additional Visibility for Innovative Products</h4>
        <p>Additional Visibility</p>
        <li>Visibility Tiers + Fulfilments</li>
        <p>3X Visibility + Video Ad: This will be visible to customer those are searching the similar product, in small window. This visibility is more suitable those who wants to attract more buyers</p>
        <p>1X Visibility + Video Ad. :This will be visible to Web visitor in small window . Ideal for new innovative product</p>
        <p>Power pack Images Visibility : Details of product and when product With image scrolling when web visitor visited the site when click on image directed to product details this as per visibility module selected.</p>

        <li>For Innovative Products: Additional visibility options are available:</li>
      <p>1X + Video and 3X + Video, with charges based on product type and client requirements, providing extra exposure to your innovative offerings.( SHORT VIDEO)</p>

      <li>For Innovative Products: You can enhance your product's exposure with additional visibility</li>
      <p>1X + Video and 3X + Video, tailored to product type and buyer requirements. </p>

      <li>Power pack Visibility Image visibility: Fast forward your selling and product visit.</li>

      <h4 className="font-semibold mt-2">"Visibility Charges by Price & Visibility Options." For Sale By Seller.</h4>
      <p> <strong>1) Master’s In Industry: </strong>For Product Value ₹500000/- and above (Ideal for Equipment, seat of form work material, Bulk material, cement steel etc. </p>
      {/* <h3>For Product Value ₹500000/- and above (Ideal for Equipment, seat of form work material, Bulk material, cement steel etc.)</h3> */}
        <ul className="list-disc list-inside">
          <li>1X Visibility: ₹110000/year </li>
          <li>2X Visibility: ₹121000/year </li>
          <li>3X Visibility: ₹133100/year </li>
          <li>4X Visibility: ₹146400/year </li>
          <p>Visibility Tiers (choose based on your business needs): The above charges are applicable for registering 1 to 3 products</p>
        </ul>

        <p>For example, if Agency X registers the following products:<br/>
1.	Product ‘A’ priced at ₹55,000 (10 units available, total ₹5,50,000)<br/>
2.	Product ‘B’ priced at ₹7,50,000<br/>
3.	Product ‘C’ priced at ₹12,65,000<br/>
The charges for 1X visibility for all three products combined will be ₹1,10,000 + GST.<br/>
If another product, ‘D’, priced at ₹11,25,000, is added, the total charges will be ₹1,10,000 +
₹1,10,000 + GST.<br/>
Additionally, up to two more products can be added without extra charges, if required.<br/>
</p>

        {/* <h4 className="font-semibold mt-2">"Visibility Charges by Price & Visibility Options." For Sale By Seller.</h4> */}
      <p> <strong>2)Key Industry Experts: </strong> For Product Value ₹200000/-and above up-to ₹500000/- Below (Ideal Equipment, seat of form-work material, Bulk material, cement steel etc.)
      Visibility Tiers (choose based on your business needs): </p>
      {/* <h3> </h3> */}
        <ul className="list-disc list-inside">
          <li>1X Visibility: ₹95000/year </li>
          <li>2X Visibility: ₹104500/year </li>
          <li>3X Visibility: ₹114950/year </li>
          <li>4X Visibility: ₹126445/year </li>
          <p>The above charges are applicable for registering 1 to 5 products.</p>
        </ul>

        <p>For example, if Agency X registers the following products:<br/>
1.	Product ‘A’ priced at ₹55,000 (4 units available, total ₹2,20,000)<br/>
2.	Product ‘B’ priced at ₹3,50,000<br/>
3.	Product ‘C’ priced at ₹4,65,000<br/>
4.	Product ‘D’ priced at ₹2,65,000<br/>
5.	Product ‘E’ priced at ₹2,05,000<br/>
The charges for 1X visibility for all Five products combined will be ₹95,000 + GST.<br/>
If another product, ‘F’, priced at ₹4,25,000, is added, the total charges will be ₹95,000 + ₹95,000 + GST. Additionally, up to Four more products can be added without extra charges, if required.
</p>

        {/* <h4 className="font-semibold mt-2">"Visibility Charges by Price & Visibility Options." For Sale By Seller.</h4> */}
      <p> <strong>3)	Industry leader: </strong> For Product Value less than ₹200000/- (Ideal small Equipment, tools, plywood, small quantity bulk material, form-work items, special item, etc. ) </p>
      {/* <h3></h3> */}
        <ul className="list-disc list-inside">
          <p>Visibility Tiers (choose based on your business needs):</p>
          <li>1X Visibility: Rs. 4 x Product Value (Min ₹15000/- Maximum ₹90000/-)  </li>
          <li>2X Visibility: Rs. 6 x Product Value (Min ₹19500/- Maximum ₹99000/-) </li>
          <li>3X Visibility: Rs. 8 x Product Value(Min ₹25350/- Maximum ₹108900/-)  </li>
          <li>4X Visibility: Rs. 11 x Product Value(Min ₹32955/- Maximum ₹119790/-) </li>
          <p>The above charges are applicable for registering 1 to 8 products.</p>
        </ul>

          <p>For example, if Agency X registers the following products:<br/>
                1.	Product ‘A’ priced at ₹100 (4 units available, total ₹400)<br/>
                2.	Product ‘B’ priced at ₹3,300<br/>
                3.	Product ‘C’ priced at ₹250 (2 units available, total ₹500)<br/>
                4.	Product ‘D’ priced at ₹210 (5 units available, total ₹1,050)<br/>
                5.	Product ‘E’ priced at ₹25 (2 units available, total ₹50)<br/>
                6.	Product ‘F’ priced at ₹80 (4 units available, total ₹320)<br/>
                7.	Product ‘G’ priced at ₹95<br/>
                8.	Product ‘H’ priced at ₹3,950<br/>
</p>
        <p>The charges for 1X visibility for all eight products combined will be based on the highest value product, which is Product ‘H’ priced at ₹3,950. So, the total visibility charge for the service will be 4 times ₹3,950 = ₹15,800 + GST.</p>
        <p>If another product is added (e.g., Product ‘I’ priced at ₹15,000), the charges will be updated as follows:</p>
        <li>Total visibility charges = ₹60,000 + ₹15,000 + GST,</li>
        <li>Up to 7 more products can be added without incurring extra charges as long as the value of the new 6 products is less than ₹15,000. And, one product value should be less than ₹3750, However, if any additional product's value exceeds ₹15,000, the new product value will be considered for the charges.
</li>

        {/* Visibility Selection Form */}
        <form onSubmit={handleSubmit} className="mt-4">
        
          

          

          {/* Terms and Conditions */}
          <div className="mt-2 flex items-center">
            <input
              type="checkbox"
              id="terms"
              checked={termsAccepted}
              onChange={() => setTermsAccepted(!termsAccepted)}
              className="w-4 h-4"
            />
            <label htmlFor="terms" className="ml-2 text-xs">I agree to the Terms and Conditions</label>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className={`mt-3 w-full p-2 text-white rounded-md text-xs ${
              termsAccepted ? "bg-blue-600 hover:bg-blue-700" : "bg-gray-400 cursor-not-allowed"
            }`}
            disabled={!termsAccepted}
          >
          Proceed
           </button>
        </form>
      </div>
    </div>
  );
};

export default DirectSale;
